<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="action"
          slot-scope="text, record"
        >
          <a-button
            type="link"
            @click="handleLook(record)"
          >预览</a-button>
          <a-button
            type="link"
            @click="handleEdit(record.agree_id)"
          >编辑</a-button>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <!-- 协议编辑弹框 -->
    <agreement-form-modal ref="AgreementFormModal" @success="agreementSuccess" />
    <!-- 协议预览弹框 -->
    <agreement-preview-modal ref="AgreementPreviewModal" />
  </div>
</template>

<script>
import { TcgTable } from '@/components'
import AgreementFormModal from './components/AgreementFormModal'
import AgreementPreviewModal from './components/AgreementPreviewModal'
import { getAgreementList } from '@/api/agreement'

const defaultQueryParam = {}

export default {
  name: 'AgreementManageIndex',
  components: { TcgTable, AgreementFormModal, AgreementPreviewModal },
  data() {
    return {
      queryParam: Object.assign({}, defaultQueryParam),
      columns: [
        {
          title: 'ID',
          dataIndex: 'agree_id'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name'
        },
        {
          title: '协议名称',
          dataIndex: 'title'
        },
        {
          title: '更新时间',
          dataIndex: 'update_time'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: (parameter) => {
        return getAgreementList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      }
    }
  },
  created() {
  },
  methods: {
    // 预览
    handleLook(record) {
      this.$refs.AgreementPreviewModal.showModal(record.url)
    },
    // 编辑
    handleEdit(id) {
      this.$refs.AgreementFormModal.showModal(id)
    },
    // 保存协议成功
    agreementSuccess() {
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style lang="less" scoped>
.tenant-card {
  line-height: 50px;
  .logo {
    float: left;
    margin-right: 40px;
  }
  .name {
    font-size: 20px;
    font-weight: bolder;
  }
  .f16 {
    font-size: 16px;
  }
  .f12 {
    font-size: 12px;
  }
  .fwb {
    font-weight: bolder;
  }
  .gray {
    color: #cccccc;
  }
}
</style>
